import http from 'hub-http/clients/apiClient';
export function fetchWorkflowsRequest(emailId) {
  return http.get(`cosemail/v1/emails/${emailId}/workflows`, null);
}